import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-refer-afriend',
  templateUrl: './refer-afriend.component.html',
  styleUrls: ['./refer-afriend.component.css']
})
export class ReferAFriendComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
